import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons"
import { scanSources } from "../../constants"

const radiologistName = ({ FirstName, LastName, Credentials }) =>
  `${FirstName} ${LastName}${Credentials ? `, ${Credentials}` : ""}`

const PatientLine = ({ log, detail, videos }) => {
  // Age 0 is a real value for an infant, so this tests for presence, not truth.
  const hasAge = detail?.PatientAge !== null && detail?.PatientAge !== undefined

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-2.5">
        {hasAge && (
          <span className="text-sm font-medium text-gray-900">
            {detail.PatientAge}y · {detail.PatientGender}
          </span>
        )}

        {detail?.BodyPart && (
          <span className="rounded-full border border-blue-200 bg-blue-50 px-2.5 py-0.5 text-xs text-blue-700">
            {detail.BodyPart}
          </span>
        )}

        {log.radiologistProfile && (
          <span className="text-sm text-gray-500">
            Reading radiologist: {radiologistName(log.radiologistProfile)}
          </span>
        )}
      </div>

      {/* source=preview keeps internal QA out of the customer-facing scan counts.
        A record with no videos has nothing to preview. */}
      {log.ReportVideosUuid && videos.length > 0 && (
        <a
          className="inline-flex items-center gap-1.5 rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-primary/80"
          href={`${window.location.origin}/educational-videos/${log.ReportVideosUuid}?source=${scanSources.PREVIEW}`}
          rel="noopener noreferrer"
          target="_blank"
          title="Opens the patient page; flagged as an internal preview so it is not counted as a scan"
        >
          <FontAwesomeIcon
            className="h-3 w-3"
            icon={faArrowUpRightFromSquare}
          />
          Preview
        </a>
      )}
    </div>
  )
}

export default PatientLine
